// Service Cloud (custhelp.com), which hosts the OPA form frame, returns
// {"code":"401","message":"Unauthorized"} for Chrome/Chromium below this major
// version (CLOS-14562). Override with the opaMinChromeVersion config key; 0 disables.
export const DEFAULT_OPA_MIN_CHROME_VERSION = 140

const CHROMIUM_TOKEN = /Chrome\/(\d+)/
const EDGE_TOKEN = /EdgA?\/(\d+)/

export const getOpaMinChromeVersion = (
  configured?: string | number
): number => {
  if (configured === undefined || configured === null || configured === '') {
    return DEFAULT_OPA_MIN_CHROME_VERSION
  }

  const parsed = Number(configured)

  return Number.isInteger(parsed) && parsed >= 0
    ? parsed
    : DEFAULT_OPA_MIN_CHROME_VERSION
}

/**
 * True when the browser reports Chrome or Chromium (Edge and Chrome Mobile
 * included, they carry the same token) below the minimum version. Firefox,
 * Safari and unknown agents never match.
 */
export const isOutdatedChromium = (
  minVersion: number,
  userAgent: string = window.navigator.userAgent
): boolean => {
  if (minVersion <= 0) {
    return false
  }

  const match = CHROMIUM_TOKEN.exec(userAgent)

  return match !== null && Number.parseInt(match[1], 10) < minVersion
}

/**
 * Returns the minimum for the outdated browser. Edge reports both its own
 * version and a Chrome version, so its desktop/Android token takes precedence.
 * Other Chrome-token agents keep the existing Chromium fallback behavior.
 */
export const getOutdatedBrowserMinVersion = (
  minChromeVersion: number,
  minEdgeVersion: number,
  userAgent: string = window.navigator.userAgent
): number | undefined => {
  const edgeMatch = EDGE_TOKEN.exec(userAgent)
  const match = edgeMatch ?? CHROMIUM_TOKEN.exec(userAgent)
  const minVersion = edgeMatch ? minEdgeVersion : minChromeVersion

  return minVersion > 0 &&
    match !== null &&
    Number.parseInt(match[1], 10) < minVersion
    ? minVersion
    : undefined
}
